<template>
  <v-dialog
    v-model="dialog"
    width="500"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <v-btn
          icon
          @click="closeDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn> 
      </v-card-title>
      <v-card-text>
        <gateways
          v-if="dialog"
          :invoice-id="invoiceId"
          @closeDialog="closeDialog"
        />
      </v-card-text>
    </v-card>  
  </v-dialog>
</template>

<script>

import Gateways from '@/views/Gateways/partial/Gateways.vue'

export default {
  name: 'HelperAccpetTerms',
  components: {
    Gateways
  },
  props: {
    terms: {
      type: Array,
      default() {
        return []
      }
    },
    invoiceId: {
      type: String,
      default() {
        return null
      }
    }
  },
  data: () => ({
    acceptTerms: false,
    dialog: false,
    showGateway: false,
    error: null,
    loading: false
  }),
  methods: {
    open() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false
    },
  }
}
</script>

<style lang="scss">
.accept-terms {
  .v-card__title {
    margin-bottom: 0!important;
  }
}

</style>
